module.exports = __webpack_public_path__ + "static/media/PoundCake.6cd8451c.jpg";